<template>
  <div>
    <keep-alive >
      <router-view v-if="$route.meta && $route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!($route.meta && $route.meta.keepAlive)"></router-view>
  </div>
</template>

<script>
// import "./variable.scss";
export default {
  name: 'Route',
  mounted() {
    rmt.configShare({
      // 设置"分享到微信"数据
      wechat: {
        title: '上海市嘉定区公共招聘平台', // 标题
        summary:
          '上海市嘉定区公共招聘平台', // 简介
        link: 'https://job.shmedia.tech/jiading/job/index', // 链接地址
        imageUrl: '' // 配图
      },
      // 设置"分享到朋友圈"数据
      wechatMoment: {
        title: '上海市嘉定区公共招聘平台',
        summary:
          '上海市嘉定区公共招聘平台',
        link: 'https://job.shmedia.tech/jiading/job/index',
        imageUrl: ''
      },
      // 设置"分享到QQ"数据
      qq: {
        title: '上海市嘉定区公共招聘平台',
        summary:
          '上海市嘉定区公共招聘平台',
        link: 'https://job.shmedia.tech/jiading/job/index',
        imageUrl: ''
      },
      // 设置"分享到QQ空间"数据
      qqZone: {
        title: '上海市嘉定区公共招聘平台',
        summary:
          '上海市嘉定区公共招聘平台',
        link: 'https://job.shmedia.tech/jiading/job/index',
        imageUrl: ''
      },
      // 设置"分享到微博"数据
      weibo: {
        title: '上海市嘉定区公共招聘平台',
        summary:
          '上海市嘉定区公共招聘平台',
        link: 'https://job.shmedia.tech/jiading/job/index',
        imageUrl: ''
      }
    })
  }
}
</script>
